import React, { Component } from 'react';
import Footer from '../../common/footer';
import Header from '../../common/header';
import { Link } from "react-router-dom";
import { ScaleLoader } from 'react-spinners';
import { css } from "react-emotion";
import API from "@aws-amplify/api";
import aws_exports from "../../aws-exports";	
import Amplify from "aws-amplify";	
import PageNotFound from "../pageNotFound";	
import "@fancyapps/fancybox";
import { connect } from "react-redux";
import "../../assets/css/main.css";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`; 

let apiName = "preferencecenter";
let path = "/users";

class SearchScreen extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            refId: "",
            bill: "",
            refIdError: false,
            submit: false
        };
    }

    handleChange = (event) => {
        if(event.target.value !== "") {
            this.setState({
                refId: event.target.value,
                refIdError: false
            });
        } else {
            this.setState({ refId: "" });
        }
    }

    handleSubmit = event => {
        event.preventDefault();
        // console.log("handleSubmit");
        let myInit1 = {
            headers: {
              referenceId: this.state.refId.toLowerCase()
            }
        };
        if(this.state.refId === "") {
            this.setState({ refIdError : true })
        } else {
            this.setState({
                loading: true,
            })
            API.get(apiName, path, myInit1).then(response => {
                // console.log("response")
                // console.log(response)
                if(response.length > 0) {
                    localStorage.setItem("ref", "yes");
                    localStorage.setItem("mKey", response[0].mKey);
                    localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
                    localStorage.setItem("uniqueKey", response[0].uniqueKey);
                    localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
                    localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
                    localStorage.setItem("classification", response[0].classification);
                    localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
                    localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
                    localStorage.setItem("smsGlobal", response[0]["preferences"]["global"]["sms"]["status"]);
                    localStorage.setItem("emailNewstips", response[0]["preferences"]["newsTips"]["email"]["status"]);
                    localStorage.setItem("mailNewstips", response[0]["preferences"]["newsTips"]["mail"]["status"]);
                    this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
                    this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
                    
                    this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
                    
                    this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
                    
                    if (response[0].classification === "DIRECT") {
                        this.setState({ bill: "CONSTELLATION_ENERGY", submit: true });
                        this.props.history.push({
                            pathname: "/update",
                            search: "?ReferenceID="+ this.state.refId +"&ProgramGroupID=CONSTELLATION_ENERGY"
                        });
                    } else if (response[0].classification === "UTILITY") {
                        this.setState({ bill: "CONSTELLATION_UTILITY_BILLED", submit: true });
                        this.props.history.push({
                            pathname: "/update",
                            search: "?ReferenceID="+ this.state.refId +"&ProgramGroupID=CONSTELLATION_UTILITY_BILLED"
                        });
                    }
                } else {
                    this.setState({ loading: false, refIdError: true})
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false, refIdError: true})
            });
        }
    }
    componentDidMount() {
        // console.log("componentDidMount")
        let params = new URLSearchParams(document.location.search.substring(1));
        let rid = params.get("ReferenceID");
        if(rid !== null) {
            // console.log(rid);
            let myInit1 = {
                headers: {
                  referenceId: rid.toLowerCase()
                }
            };
            API.get(apiName, path, myInit1).then(response => {
                if(response.length > 0) {
                    console.log(response);
                    localStorage.setItem("mKey", response[0].mKey);
                    localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
                    localStorage.setItem("uniqueKey", response[0].uniqueKey);
                    localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
                    localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
                    localStorage.setItem("classification", response[0].classification);
                    
                    this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
        
                    localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
                    localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
                    this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
                    
                    this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
                    
                    this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
                    localStorage.setItem("smsGlobal", response[0]["preferences"]["global"]["sms"]["status"]);
                    localStorage.setItem("emailNewstips", response[0]["preferences"]["newsTips"]["email"]["status"]);
                    localStorage.setItem("mailNewstips", response[0]["preferences"]["newsTips"]["mail"]["status"]);
                    
                    if (response[0].classification === "DIRECT") {
                        // this.setState({ bill: "CONSTELLATION_ENERGY", submit: true, refId: rid });
                        this.props.history.push({
                            pathname: "/update",
                            search: "?ReferenceID="+ rid +"&ProgramGroupID=CONSTELLATION_ENERGY"
                        });
                    } else if (response[0].classification === "UTILITY") {
                        // this.setState({ bill: "CONSTELLATION_UTILITY_BILLED", submit: true, refId: rid });
                        this.props.history.push({
                            pathname: "/update",
                            search: "?ReferenceID="+ rid +"&ProgramGroupID=CONSTELLATION_UTILITY_BILLED"
                        });
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.props.history.push("/")
            });
        }
    }

    render() {
        // if(this.state.submit) {
            // this.props.history.push({
            //     pathname: "/update",
            //     search: "?ReferenceID="+ this.state.refId +"&ProgramGroupID=" + this.state.bill
            // });
        // }
        return (
            <React.Fragment>
                <Header/>
                <main className="home-bg">
                
                    <div className="container loginFont ">
                        <div className="row justify-content-center align-items-center">

                            <div className="col-md-6 loginForm">
                            <h4 className="text-center " style={{ color: "#81CFE7", fontWeight: "bold" }}>My Communication Preferences</h4>
                            <p className="text-left" style={{color:"grey"}}>Did you know that Constellation offers account notifications via text, as well as news and tips via email?</p> 
                            <p className="text-left" style={{color:"grey"}}>You can manage your communication preferences at any time by entering your Reference Number below, or click on your Customer Type to enter your service address!</p>
                            <p className="text-left" style={{color:"grey"}}></p>
                            <p className="text-left" style={{color:"grey"}}></p>
                                <p className="text-left" style={{color:"grey"}}>To edit your preferences using a provided Reference Number, please enter it below.</p>
                                <form
                                    id="login-form"
                                    className="form-horizontal"
                                    onSubmit={this.handleSubmit}
                                    style={{ padding: "15px" }}
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="formInput text-center">
                                                {/* <label className="col-5">
                                                    *Reference Number:
                                                </label> */}
                                                <input
                                                    className="form-control col-8 loginInput "
                                                    id="refId"
                                                    name="refId"
                                                    type="text"
                                                    onChange={event =>
                                                    this.handleChange(event, "refId")
                                                    }
                                                    value={this.state.refId}
                                                />
                                                <button
                                                    style={{ minWidth: "100px"}}
                                                    className={this.state.loading ? "hidden" : " col-4 button"}
                                                    id="search"
                                                >
                                                    SUBMIT
                                                </button>
                                                <div
                                                    className={this.state.loading ? "sweet-loading" : "hidden"}
                                                    style={{float: "right"}}
                                                >
                                                    <ScaleLoader
                                                        className={override}
                                                        sizeUnit={"px"}
                                                        size={20}
                                                        color={"rgb(244, 123, 39)"}
                                                        loading={this.state.loading}
                                                    />
                                                </div>
                                            </div>
                                            <div className={this.state.refIdError ? "col-8 text-center error fontSmall" : "hidden"}
                                            >
                                                Please provide a valid reference id.
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <hr/>
                                <p className="text-left fontMedium" style={{color: "grey"}}>If you do not have a reference number, please select your customer type below.</p>
                                <div className="">
                                    <div className="text-center">
                                        <Link to="/residential-account">
                                            <button
                                                style={{ marginRight: "10px", width:"140px" }}
                                                type="submit"
                                                name="submit"
                                                className="button"
                                            >
                                                RESIDENTIAL
                                            </button>
                                        </Link>
                                        <Link to="/smb-account">
                                            <button
                                                style={{ width:"140px" }}
                                                type="submit"
                                                name="submit"
                                                className="button"
                                            >
                                                BUSINESS
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer/>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    reduxEmail: state.reduxEmail,
    reduxPhone: state.reduxPhone,
    reduxStreet: state.reduxStreet,
    reduxZip: state.reduxZip
});

export default connect(mapStateToProps)(SearchScreen);


// WEBPACK FOOTER //
// ./src/views/CustomerPages/SearchScreen.jsx